export const ProcessPoster = () => {
  return null;
};
